<app-state-section [state]="sectionState">
  <mat-card>
    <mat-card-content>
      <form [formGroup]="form" *ngIf="form">
        <app-row gutter="sm">
          <app-col cols="12" *ngIf="!item && showLocationDetailsInputs" class="form-type">
            <mat-label class="d-block text-400 mb-0 asterisk-after">{{ "Location.Labels.FormType" | translate }}</mat-label>
            <mat-radio-group formControlName="formType">
              <mat-radio-button color="primary" [value]="ShipmentCreationTemplateTypes.Basic"></mat-radio-button>
              <mat-label class="text-700">{{ "Location.Labels.Basic" | translate }}</mat-label>
              <mat-radio-button color="primary" [value]="ShipmentCreationTemplateTypes.Orders"></mat-radio-button>
              <mat-label class="text-700">{{ "Location.Labels.Nupco" | translate }}</mat-label>
              <mat-radio-button color="primary" [value]="ShipmentCreationTemplateTypes.Cement"></mat-radio-button>
              <mat-label class="text-700">{{ "Location.Labels.Ycc" | translate }}</mat-label>
            </mat-radio-group>
          </app-col>
          <div>
            <app-col sm="12" class="flex column">
              <div class="label mt-3 mb-2 d-block text-black weight-medium">{{ "Location.Labels.GoogleMapsURL" | translate }}</div>
              <div class="flex">
                <mat-form-field appearance="outline" class="d-block w-100 mr-2 radius-3">
                  <input formControlName="link" matInput type="text" [placeholder]="'Location.Labels.GoogleMapsURLPlaceholder' | translate" />
                  <mat-error *ngIf="form.invalid && form.get('link').touched && form.get('link').hasError('invalidMapCoordinates')">
                    {{ "ErrorMessages.InValidData" | translate }}
                  </mat-error>
                </mat-form-field>
                <button mat-flat-button class="radius-3 py-5 px-4 text-white bg-primary-200 weight-normal text-nowrap" (click)="detectMapURL()" [disabled]="isDetecting">
                  <mat-spinner *ngIf="isDetecting" diameter="16" class="d-inline-block mr-1"></mat-spinner>
                  {{ 'Location.Labels.Detect' | translate}}
                </button>
              </div>

              <div *ngIf="urlLocationFound" class="location-found-banner flex align-center justify-center mt-2 px-3 py-2 radius-2">
                <app-icon name="outline-tick-circle" class="text-success mr-2" size="sm"></app-icon>
                <span class="text-success small weight-medium">
                  {{ 'Location.Labels.LocationFound' | translate }}: {{ latitude | number:'1.4-4' }}, {{ longitude | number:'1.4-4' }}
                </span>
              </div>

              <div *ngIf="urlDetectError" class="url-detect-error-banner flex align-center justify-center mt-2 px-3 py-2 radius-2">
                <app-icon name="outline-close-circle" class="text-danger mr-2" size="sm"></app-icon>
                <span class="text-danger small weight-medium">{{ 'Location.Labels.UrlDetectError' | translate }}</span>
              </div>
            </app-col>

            <div class="divider-with-text flex align-center my-4">
              <mat-divider class="bg-300"></mat-divider>
              <span class="small text-500 mx-3">{{'Location.Labels.OrSearchLocation' | translate}}</span>
              <mat-divider class="bg-300"></mat-divider>
            </div>

            <app-col sm="12" class="flex column">
              <div class="label mb-2 d-block text-black weight-medium">{{ "Location.Labels.SearchAddress" | translate }}</div>
              <div class="flex">
                <app-autocomplete-google-maps
                  class="w-100 mr-2 mb-5 radius-1"
                  formControlName="searchAddress"
                  [placeholder]="'Location.Labels.SearchAddressPlaceholder' | translate"
                  >
                </app-autocomplete-google-maps>
              </div>
            </app-col>

            <div class="flex map" *ngIf="hasLocationPermission && googleMapLoaded" style="height: 400px; width: 100%">
              <google-map *ngIf="latitude && longitude" [center]="{lat: +latitude, lng: +longitude }" [zoom]="zoom" (mapClick)="markerDragEnd($event)">
                <map-marker [position]="{lat: +latitude, lng: +longitude }" [options]="{ draggable: true }" (mapDragend)="markerDragEnd($event)"></map-marker>
              </google-map>
            </div>

            <div *ngIf="pinLocationFound" class="location-found-banner flex align-center justify-center mt-2 px-3 py-2 radius-2">
              <app-icon name="outline-tick-circle" class="text-success mr-2" size="sm"></app-icon>
              <span class="text-success small weight-medium">
                {{ 'Location.Labels.LocationFound' | translate }}: {{ latitude | number:'1.4-4' }}, {{ longitude | number:'1.4-4' }}
              </span>
            </div>

            <mat-divider class="my-3 bg-300"></mat-divider>

            <mat-expansion-panel *ngIf="showLocationDetailsInputs" class="bg-100 mat-elevation-z0 expansion-panel-wrapper">
              <mat-expansion-panel-header class="pl-0">
                <mat-panel-title>
                  <app-icon class="text-500 mr-2" size="sm" name="outline-location"></app-icon>
                  <span class="text-400 small">{{ "Location.Labels.ManualCoordinatesEntry" | translate }}</span>
                </mat-panel-title>
              </mat-expansion-panel-header>

              <p class="text-500 small mb-6">{{'Location.Labels.EnterCoordinatesManually' | translate}}</p>

              <app-row>
                <app-col sm="6">
                  <mat-label class="label asterisk-after">{{ "Location.Labels.Latitude" | translate }}</mat-label>
                  <mat-form-field appearance="outline" class="w-100">
                    <input matInput type="number" [value]="latitude" (keyup)="onLatitudeValueChange($event.target.value)" />
                    <mat-error
                      *ngIf="!latitude
                    "
                    >
                      {{ "ErrorMessages.Required" | translate }}
                    </mat-error>
                  </mat-form-field>
                </app-col>

                <app-col sm="6">
                  <mat-label class="label asterisk-after">{{ "Location.Labels.Longitude" | translate }}</mat-label>
                  <mat-form-field appearance="outline" class="w-100">
                    <input matInput type="number" [value]="longitude" (keyup)="onLongitudeValueChange($event.target.value)" />
                    <mat-error
                      *ngIf="!longitude
                    "
                    >
                      {{ "ErrorMessages.Required" | translate }}
                    </mat-error>
                  </mat-form-field>
                </app-col>
              </app-row>
            </mat-expansion-panel>
          </div>
          <ng-container *ngIf="showLocationDetailsInputs">
            <div class="flex align-center pl-0">
              <div class="boxed-icon boxed-icon--accent-50 boxed-icon--border-none boxed-icon--size p-2 boxed-icon--margin boxed-icon--radius mx-0 mr-3">
                <app-icon class="text-accent" name="bold-document-text" size="sm"></app-icon>
              </div>
              <span class="text-800 weight-semibold">{{ "Location.Labels.LocationDetails" | translate }}</span>
            </div>
            <app-col [cols]="hasOrdersTemplate ? 12 : 6">
              <mat-label class="label d-block w-100 asterisk-after">{{ "Location.Labels.LocationName" | translate }}</mat-label>
              <mat-form-field appearance="outline" class="d-block w-100">
                <input matInput type="text" formControlName="name" [placeholder]="'Placeholder.EnterLocationName' | translate" />
                <mat-error *ngIf="form.invalid && form.get('name').touched && form.get('name').hasError('required')">
                  {{ "ErrorMessages.Required" | translate }}
                </mat-error>
                <mat-error *ngIf="form.invalid && form.get('name').touched && form.get('name').hasError('whitespace')">
                  {{ "ErrorMessages.InValidData" | translate }}
                </mat-error>
              </mat-form-field>
            </app-col>
            <app-col sm="6" *ngIf="type === LocationType.Customer">
              <mat-label class="label d-block w-100 asterisk-after">
                {{ "Location.Labels.Contacts" | translate }}
                <span *ngIf="form.get('shippingType').value" (click)="addUserModal.showModal()" class="link">
                  {{'Location.AddNewContact' | translate}}
                </span>
              </mat-label>
              <app-dropdown
                formControlName="contacts"
                [placeholder]="'Placeholder.SelectContact' | translate"
                [list]="contacts"
                [multipleMode]="true"
                [required]="form.get('shippingType').value ? true : false"
                [selectAllByDefault]="contacts?.length === 1 ? true : false"
              ></app-dropdown>
            </app-col>
            <app-col sm="6" *ngIf="type === LocationType.Customer && form.get('contacts').value?.length">
              <mat-label class="label d-block w-100 asterisk-after">{{ "Location.Labels.DefaultContact" | translate }}</mat-label>
              <app-dropdown
                formControlName="defaultUser"
                [placeholder]="'Placeholder.SelectContact' | translate"
                [list]="form.get('contacts').value"
                [required]="form.get('contacts').value.length ? true : false"
              ></app-dropdown>
            </app-col>
            <app-col sm="6">
              <mat-label class="label asterisk-after">{{ "Location.Labels.City" | translate }}</mat-label>
              <app-lazy-dropdown
                formControlName="city"
                [lookup]="LookupType.Cities"
                [placeholder]="'Placeholder.SelectCity' | translate"
                [lookupExtraParams]="{ status: 'ACTIVE' ,businessType: BusinessType.B2B }"
                [filter]="filterCitiesHandler"
              >
                <mat-error
                  *ngIf="
                  form.invalid &&
                  form.get('city').touched &&
                  form.get('city').hasError('required')
                "
                >
                  {{ "ErrorMessages.Required" | translate }}
                </mat-error>
              </app-lazy-dropdown>
            </app-col>

            <app-col sm="12">
              <mat-label class="label d-block w-100">{{ "Location.Labels.DetaildAddress" | translate }}</mat-label>
              <mat-form-field appearance="outline" class="d-block w-100">
                <input matInput type="text" [value]="address" readonly [placeholder]="'Location.Labels.DetaildAddressPlaceholder' | translate" />
              </mat-form-field>
            </app-col>


            <app-col sm="6" *ngIf="hasCementTemplate">
              <mat-label class="label d-block w-100">{{ "Inputs.Region" | translate }}</mat-label>
              <app-dropdown formControlName="wccRegion" [placeholder]="'Placeholder.SelectRegion' | translate" [list]="wccRegions"></app-dropdown>
            </app-col>
            <app-col sm="6" *ngIf="hasCementTemplate">
              <mat-label class="label d-block w-100">{{ "Inputs.Receiver" | translate }}</mat-label>
              <app-dropdown formControlName="wccReceiver" [placeholder]="'Placeholder.SelectReceiver' | translate" [list]="wccReceivers"></app-dropdown>
            </app-col>
            <app-col sm="6" *ngIf="type === LocationType.Customer">
              <mat-label class="label d-block w-100 mb-0 asterisk-after">{{ "Inputs.ShippingType" | translate }}</mat-label>
              <mat-radio-group formControlName="shippingType">
                <mat-radio-button *ngFor="let type of ShippingType | enumToArray " [value]="type.value" class="mr-3">
                  {{ 'Enum.ShippingType.' + type.value | translate }}
                </mat-radio-button>
                <mat-error
                  *ngIf="
                  form.invalid &&
                  form.get('shippingType').touched &&
                  form.get('shippingType').hasError('required')
                "
                >
                  {{ "ErrorMessages.Required" | translate }}
                </mat-error>
              </mat-radio-group>
            </app-col>
          </ng-container>
        </app-row>
      </form>

      <ng-container *ngIf="showLocationDetailsInputs">
        <div class="py-4">
          <mat-divider class="pos-static"></mat-divider>
        </div>

        <ng-container *ngIf="hasOrdersTemplate">
          <div class="flex align-center pl-0 mb-3">
            <div class="boxed-icon boxed-icon--accent-50 boxed-icon--border-none boxed-icon--size p-2 boxed-icon--margin boxed-icon--radius mx-0 mr-3">
              <app-icon class="text-accent" name="bold-house" size="sm"></app-icon>
            </div>
            <span class="text-800 weight-semibold">{{ "sharedFeatures.GateDefinition.GatesManagement" | translate }}</span>

            <button mat-button class="flex align-center ml-auto brd brd-200 text-black weight-medium radius-2" [disabled]="gateDefinitionForms?.invalid" (click)="addGateDefinition()">
              <app-icon name="outline-add"></app-icon>
              <span>{{ "sharedFeatures.GateDefinition.addGate" | translate }}</span>
            </button>
          </div>

          <div *ngFor="let control of gateDefinitionForms?.controls; let i = index; let last = last">
            <mat-divider class="mb-3"></mat-divider>
            <app-row>
              <app-col>
                <app-gate-definition [formControl]="control"></app-gate-definition>
              </app-col>
              <app-col cols="auto">
                <div class="text-center">
                  <button mat-button type="button" class="container__button" [matTooltip]="'Buttons.Remove' | translate" (click)="removeGateDefinition(i)">
                    <app-icon name="remove" class="m-0 text-300"></app-icon>
                  </button>
                </div>
              </app-col>
            </app-row>
          </div>

          <div *ngIf="!gateDefinitionForms?.controls?.length" class="py-7 text-center brd brd-dashed brd-300 bg-100 radius-3">
            <div class="text-500">{{'sharedFeatures.GateDefinition.addGateDesc' | translate}}</div>
          </div>
          <div class="py-4">
            <mat-divider class="pos-static"></mat-divider>
          </div>
        </ng-container>
      </ng-container>
    </mat-card-content>
  </mat-card>

  <div class="flex justify-flex-end mt-4" *ngIf="!hideActions">
    <button mat-button class="mr-3 btn-secondary" (click)="closeModal.emit()">{{ cancelBtnText | translate}}</button>

    <button
      mat-flat-button
      color="primary"
      (click)="onSaveClicked()"
      [disabled]="(form && form.invalid) || !latitude || latitude == 0 || !longitude || longitude == 0 "
    >
      {{ actionBtnText | translate}}
    </button>
  </div>
</app-state-section>

<app-modal #addUserModal [title]=" 'Location.AddNewContact' | translate" [maxWidth]="1100" [padding]="20" [textColor]="'var(--color-on-surface-high-emphasis)'" [editCloseIcon]="true">
  <div *ngIf="addUserModal.isModalOpened">
    <app-user-form
      [userType]="UserType.CUSTOMER"
      [id]="item?.parentId"
      [shippingType]="form?.get('shippingType')?.value"
      (close)="addUserModal.closeModal()"
      (update)="handleAddNewContactEvent($event)"
    ></app-user-form>
  </div>
</app-modal>
